import React, { useEffect, useState } from "react";
import Tooltip from "components/Inputs/Tooltip";
import styles from "./style.module.css";
import { useDispatch, useSelector } from "types/store";
import { addRating, fetchRatings, getRatingsById } from "containers/Ratings/reducer";
import { Button, Icon } from "aible";
import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";
const FeedbackPopover = ({ value, type, feedback, users, fetchRatings }) => {
    const [isLoading, updateIsLoading] = useState(false);
    useEffect(() => {
        const count = getFeedbackCount(value, feedback);
        if (count != users.length) {
            updateIsLoading(true);
            fetchRatings(type, value).finally(() => updateIsLoading(false));
        }
    }, [type, value.id, feedback]);
    return (React.createElement("div", { className: styles.userList }, isLoading ? React.createElement(LoadingIndicator, null) : users?.map((user) => React.createElement("div", { key: user?.id }, user?.fullname))));
};
const FEEDBACK_ICONS = {
    LIKE: "thumbsUpPurple",
    DISLIKE: "thumbsDownPurple",
    NONE: ""
};
const getFeedbackCount = (value, feedback) => {
    switch (feedback) {
        case "LIKE":
            return value.like_count;
        case "DISLIKE":
            return value.dislike_count;
        case "NONE":
            return 0;
    }
};
const FeedbackButton = ({ value, type, feedback, isDisabled, updateIsDisabled, disallowedFeedback, afterUpdate, iconSize, buttonStyle }) => {
    const dispatch = useDispatch();
    const [isLoading, updateIsLoading] = useState(false);
    const feedbackCount = getFeedbackCount(value, feedback);
    const handleClick = () => {
        updateIsLoading(true);
        dispatch(addRating(type, value.id, value.feedback == feedback ? "NONE" : feedback))
            .then((rating) => afterUpdate?.(rating.score))
            .finally(() => {
            updateIsLoading(false);
            updateIsDisabled?.(false);
        });
    };
    const ratings = useSelector((state) => getRatingsById(state, type, value.id));
    const users = Object.values(ratings)
        .filter((rating) => rating.score == feedback)
        .map((rating) => rating.created_by);
    return (React.createElement(Tooltip, { trigger: feedbackCount > 0 ? ["hover", "focus"] : [], overlay: React.createElement(FeedbackPopover, { value: value, type: type, feedback: feedback, users: users, fetchRatings: (type, value) => dispatch(fetchRatings(type, value)).then(() => {
                return;
            }) }) },
        React.createElement(Button, { className: styles.messageActionsButton, onClick: () => handleClick(), active: value.feedback == feedback, disabled: isLoading || isDisabled || (disallowedFeedback !== undefined && disallowedFeedback.indexOf("LIKE") >= 0), type: "secondary", isSmall: true, style: buttonStyle ?? {
                marginBottom: "4px"
            } },
            React.createElement(React.Fragment, null,
                React.createElement(Icon, { type: FEEDBACK_ICONS[feedback], size: iconSize ?? 18 }),
                isLoading || feedbackCount > 0 ? (React.createElement("span", { style: { marginLeft: "4px" } }, isLoading ? "..." : feedbackCount)) : (React.createElement(React.Fragment, null))))));
};
const RatingInput = ({ isDisabled, ...props }) => {
    const [isDisabledState, updateIsDisabled] = useState(false);
    return (React.createElement(React.Fragment, null,
        React.createElement(FeedbackButton, { feedback: "LIKE", isDisabled: isDisabled || isDisabledState, updateIsDisabled: updateIsDisabled, ...props }),
        React.createElement(FeedbackButton, { feedback: "DISLIKE", isDisabled: isDisabled || isDisabledState, updateIsDisabled: updateIsDisabled, ...props })));
};
export default RatingInput;
